<!-- @format -->

<template>
    <BaseBanner class="gst-checkout_earn-banner pa-2">
        <template #content>
            <slot :points="pointsFormatted">
                <span class="gst-checkout_earn-banner-title">
                    {{ $t('_components.earnBanner.title') }}
                </span>
                <span class="gst-checkout_earn-banner-points">
                    {{
                        $t(
                            'shared:components.bonusPoints.bonusPointsCartCheckoutConfirmation.pointWithCount',
                            { count: points, formattedCount: pointsFormatted }
                        )
                    }}
                </span>
            </slot>
        </template>
    </BaseBanner>
</template>

<script>
import BaseBanner from './BaseBanner.vue';

export default {
    name: 'EarnBanner',
    components: {
        BaseBanner,
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'views.cart.theCheckout',
    },
    props: {
        points: {
            type: Number,
            required: true,
            default: 0,
        },
    },
    computed: {
        pointsFormatted() {
            return this.$options.filters.bonusPoints(this.points);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-checkout_earn-banner {
    background:
        center right 20px / auto 67% no-repeat url('~@tenant/app/assets/logo-small.png'),
        theme-color('secondary');
    color: theme-color('white');
    font-weight: font-weight('medium');
    gap: theme-spacing(1);

    .gst-checkout_earn-banner-title {
        font-size: font-size('s');
        letter-spacing: -0.25px;
    }

    .gst-checkout_earn-banner-points {
        font-size: font-size('xxxl');
        letter-spacing: -0.357px;
    }
}
</style>
